import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { ListProject, DeleterProject, ListClient, deleteClient} from '../../../../Utility/Api';  // Import your API functions
import AddClinetForm from './form';
import { Deletemodel } from "../../../Common/Functions";  
import "../project.css"
import { NaviGate } from '../../../../Utility/function';


const Client = () => {

    const [Project, setProject] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [deleteModal, showDeleteModal] = useState(false);
    const [deleteID, setDeleteID] = useState("");
    const [selectedUnit, setSelectedUnit] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const unitsPerPage = 10;
  
    useEffect(() => {
      fetchClient();
    }, []);
 
const fetchClient = async () => {
  try {
    const response = await ListClient();
    if (response.data && response.data.data) {
      setProject(response.data.data);  
      console.log("project",response.data.data)
    } else {
      toast.error('No units found.');
    }
  } catch (error) {
    console.error('Error fetching units:', error);
    toast.error('Error fetching units');
  }
};

const openModal = (unit = null) => {
  setSelectedUnit(unit);
  setShowModal(true);
};

const handleDelete = async () => {
  try {
    await deleteClient(deleteID);  
    toast.success('Project deleted successfully');
    fetchClient(); 
    showDeleteModal(false);
  } catch (error) {
    console.error('Error deleting unit:', error);
    toast.error('Error deleting unit');
  }
};

const handleDeleteModal = (ID) => {
  showDeleteModal(true);
  setDeleteID(ID);
};

const indexOfLastUnit = currentPage * unitsPerPage;
const indexOfFirstUnit = indexOfLastUnit - unitsPerPage;
const currentProject = Project.slice(indexOfFirstUnit, indexOfLastUnit);
const totalPages = Math.ceil(Project.length / unitsPerPage);

//   const handlePageChange = (pageNumber) => {
//     setCurrentPage(pageNumber);
//   };

return (
  <div className="page-wrappers">
    <div className="page-content">
    <NaviGate />
      <h6 className="mb-0 text-uppercase">Client List</h6>
      <hr />
      <button 
        type="button" 
        onClick={() => openModal()} 
        className="btn btn-primary mb-2" 
        style={{ fontFamily: "poppins" }}>
        Add Client
      </button>
      <div className="card">
        <div className="card-body">
          <div className="table-responsive">
            <table className="table table-striped table-sm table-bordered align-baseline" style={{ width: "100%", fontFamily: "poppins" }}>
              <thead>
                <tr>
                  <th>S.No</th>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Phone</th>
                  <th>Company Name</th>
                  <th>Company Email</th>
                  <th>City</th>
                  <th>Country</th> 
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {currentProject.map((Project, index) => (
                  <tr key={Project.id}>
                    <td>{(currentPage - 1) * unitsPerPage + index + 1}</td>
                    <td>{Project.first_name} {Project.last_name}</td>
                              <td>{Project.email}</td>
                              <td>{Project.phone}</td>
                              <td>{Project.company_name}</td>
                              <td>{Project.company_email}</td>
                              <td>{Project.city}</td>
                              <td>{Project.country}</td>
                             
                    <td>
                      <img
                        src='/assets/images/icons/edit.png'
                        onClick={() => openModal(Project)}
                        height={"20px"}
                        alt="Edit"
                      />
                      <img
                        src='/assets/images/icons/delete.png'
                        className="mx-1"
                        onClick={() => handleDeleteModal(Project.id)}
                        height={"20px"}
                        alt="Delete"
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    {deleteModal && (
      <Deletemodel
        setShowModal={showDeleteModal}
        handleDelete={handleDelete}
      />
    )}
    {showModal && (
      <AddClinetForm
        openModal={showModal}
        setOpenModal={setShowModal}
        unit={selectedUnit}
        closeModal={() => setShowModal(false)}
        refreshList={fetchClient}  
      />
    )}
  </div>
);
};
export default Client